import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { ehAreaAdministrativa } from './areaAdministrativa'
import {
  carregarChatMovidesk,
  chatFoiCarregado,
  definirVisibilidadeChat,
  identificarNoChat,
} from './movidesk'
import { useChatSuporte } from './useChatSuporte'

/**
 * Widget de chat do suporte (Movidesk). Não renderiza nada: o widget é montado no body pelo script
 * do fornecedor. Fica no LayoutPage, que é o ponto comum das telas autenticadas — e é o próprio
 * componente que decide se aparece, a partir da flag do tenant e da rota.
 *
 * O script só é injetado quando o chat de fato precisa aparecer: tenant com o chat desligado, ou
 * usuário na área administrativa, não carrega script de terceiro nenhum.
 */
export function ChatSuporte() {
  const { pathname } = useLocation()
  const naVisualizacaoCartivia = !ehAreaAdministrativa(pathname)
  const dados = useChatSuporte(naVisualizacaoCartivia)

  useEffect(() => {
    if (!naVisualizacaoCartivia || dados === null) {
      // Já carregado e agora não deve aparecer (entrou no administrativo): o script não tem como
      // ser descarregado, então resta ocultar o widget.
      if (chatFoiCarregado()) {
        definirVisibilidadeChat(false)
      }
      return undefined
    }

    let cancelado = false
    carregarChatMovidesk().then(carregou => {
      if (!carregou || cancelado) return
      identificarNoChat(dados)
      definirVisibilidadeChat(true)
    })

    return () => {
      cancelado = true
      // Desmontou saindo das telas autenticadas (logout): o widget não pode ficar sobrando na
      // tela de login. Só depois de carregado — sem isso, cada desmonte dispararia uma espera
      // de 10s pelo elemento de um widget que nunca foi pedido.
      if (chatFoiCarregado()) {
        definirVisibilidadeChat(false)
      }
    }
  }, [naVisualizacaoCartivia, dados])

  return null
}
